// Breakpoints
window.breakpoints = {
    md: getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'),
    container: getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-container'),
    lg: getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg'),
    xl: getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xl'),
}

// Utilities
import 'what-input'
import 'lazysizes'
import "lazysizes/plugins/unveilhooks/ls.unveilhooks"
//import 'cookieconsent'

// Vue components (see automatic vs dynamic notes below)
import ThePrimaryNav from './components/ThePrimaryNav/ThePrimaryNav.vue'
import PrimaryNavItem from './components/ThePrimaryNav/PrimaryNavItem.vue'
import IconMainLogo from './components/Icons/IconMainLogo.vue'
import IconBeaconOneLogo from './components/Icons/IconOneBeaconLogo.vue'

// Directives
import animate from './directives/animate'
import active from './directives/active'
// import focus from './directives/focus'

// Mixins
import inlineScripts from './mixins/inline-scripts'
import breakpointMixin from './mixins/breakpointMixin'
import filtering from './mixins/filtering'
//import cookieconsent from './mixins/cookieconsent'

// Vue and Vue plugins
import Vue from 'vue'
import Scrollspy from 'vue2-scrollspy'
Vue.use(Scrollspy)
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    duration: 1000,
    offset: () => window.stickyNavHeight * -1,
    onStart: (el) => {
        window.location.hash = el.id
    }
})
import Vuex from 'vuex'
import store from './store'
import HubspotForm from './components/Hubspot/HubspotForm.vue'

Vue.use(Vuex);

// Vue instance
const vmApp = new Vue({
    el: ".js-app",
    delimiters: ['${', '}'], // Avoid collision with Twig template engine
    store,
    components: {
        // Import automatically because on every page
        ThePrimaryNav,
        PrimaryNavItem,
        IconMainLogo,
        IconBeaconOneLogo,

        // Simplebar
        'simplebar': () => import('simplebar-vue'),

        // Wrapper for VueSwiper
        'BaseCarousel': () => import('./components/BaseCarousel/BaseCarousel.vue'),
        'TestimonialSlider': () => import('./components/TestimonialSlider/TestimonialSlider.vue'),

        // Import dynamically because NOT on every page
        'ScrollSlider': () => import('./components/ScrollSlider/ScrollSlider.vue'),
        'ScrollSliderSlide': () => import('./components/ScrollSlider/ScrollSliderSlide.vue'),
        'ShapeShifterCard': () => import('./components/ShapeShifter/ShapeShifterCard.vue'),
        'CaseStudySlider': () => import('./components/CaseStudySlider/CaseStudySlider.vue'),
        'BackToTop': () => import('./components/BackToTop/BackToTop.vue'),
        'BaseAccordionItem': () => import('./components/BaseAccordion/BaseAccordionItem.vue'),
        'BaseTabs': () => import('./components/BaseTab/BaseTabs.vue'),
        'BaseTab': () => import('./components/BaseTab/BaseTab.vue'),
        'AnimatedCheckmark': () => import('./components/Icons/AnimatedCheckmark.vue'),
        'CardSlider': () => import('./components/CardSlider/CardSlider.vue'),
        'HubspotForm': () => import(/* webpackPrefetch: true */ './components/Hubspot/HubspotForm.vue'),
        'InlineScript': () => import('./components/InlineScript/InlineScript.vue'),
        'ClearlyRated': () => import('./components/ClearlyRated/ClearlyRated.vue'),

        'IconQuote': () => import('./components/Icons/IconQuote.vue'),
        'BaseModal': () => import('./components/BaseModal/BaseModal.vue'),
        'ToggleItem': () => import('./components/ToggleItem/ToggleItem.vue'),
        'ToggleGroup': () => import('./components/ToggleGroup/ToggleGroup.vue'),
        'VideoEmbed': () => import('./components/VideoEmbed/VideoEmbed.vue'),
        'IconRevealHide': () => import('./components/Icons/IconRevealHide.vue'),
        'LoadingIndicator': () => import('./components/Icons/LoadingIndicator.vue'),
        'SearchClear': () => import('./components/Icons/SearchClear.vue'),
        'IconOpenClose': () => import('./components/Icons/IconOpenClose.vue'),
        'InfogramEmbed': () => import('./components/Infogram/InfogramEmbed.vue'),
        'BaseAlert': () => import('./components/BaseAlert/BaseAlert.vue'),
        'LocationMap': () => import('./components/LocationMap/LocationMap.vue'),
        'ShareMenu': () => import('./components/ShareMenu/ShareMenu.vue'),
    },
    // store: store,
    directives: {
        animate,
        active,
        // cookieconsent,
    },
    mixins: [inlineScripts, breakpointMixin, filtering],
    data: {
        modal: null
    },
    methods: {
        openModal(id){
            this.modal = id
        },
        closeModal(){
            this.modal = null
        }
    }
})


